exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-section[data-v-2ccfe268]{margin-bottom:20px}", ""]);

// exports
